export default "/images/search_icon_ru.svg?8175c10e37d8d1074af8da5170c7c729";